import type { FindResponseInterface } from '@nts/std/interfaces';
import { GenericArrayServiceResponse } from './generic-array-service-response';
import type { IdentityInterface, ModelInterface } from '@nts/std/interfaces';

export class FindResponse<
    TModel extends ModelInterface<TIdentity>,
    TIdentity extends IdentityInterface>
    extends GenericArrayServiceResponse<TModel> implements FindResponseInterface<TModel, TIdentity> {

}
